import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/logos/Material Index Logo Final-06.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="bg-primary text-white">
      <nav className="container mx-auto flex justify-between items-center h-20 px-6">
        {/* Logo */}
        <img src={Logo} alt="Material Index Logo" className="h-14" />

        {/* Hamburger Menu Button */}
        <button
          onClick={toggleMenu}
          className="text-white text-3xl md:hidden focus:outline-none"
        >
          ☰
        </button>

        {/* Navigation Links */}
        <ul
          className={`fixed md:static top-20 right-0 bg-primary md:bg-transparent w-2/3 md:w-auto md:flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-8 items-center p-6 md:p-0 transition-all duration-300 ${
            isOpen ? "block" : "hidden"
          }`}
        >
          <li>
            <Link
              to="/"
              className="text-white hover:text-red-600 font-semibold"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className="text-white hover:text-red-600 font-medium"
              onClick={() => setIsOpen(false)}
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              to="/products"
              className="text-white hover:text-red-600 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Product
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="text-white hover:text-red-600 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Contact Us
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;
